const publicLocales = './public/locales';
const appPublicLocales = './apps/dx-hiltonlink-ui/public/locales';

/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
  i18n: {
    defaultLocale: 'default',
    localeDetection: false,
    locales: ['default', 'en'],
  },
  fallbackLng: 'en',
  defaultNS: 'common',
  debug: false,
  initImmediate: false,
  returnObjects: true,
  returnNull: false,
  partialBundledLanguages: true, // allows us to fetch namespaces that aren't in serverSideTranslations on the client, e.g. lazy loaded components
  localePath: process.env.APP_ENV === 'local' ? appPublicLocales : publicLocales,
  ignoreRoutes: [],
  lowerCaseLng: true,
  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false,
    skipOnVariables: false, // fixed a bug with it not rendering two variables together {{symbol}}{{code}}
  },
};
